export default __webpack_public_path__ + "static/media/K_Kururu.74631bbc.mp3";